{
  "name": "leaflet-ui",
  "version": "0.7.2",
  "description": "Leaflet presets for common user interface customizations",
  "main": "dist/leaflet-ui.js",
  "module": "src/leaflet-ui.js",
  "scripts": {
    "test": "node build/test.js",
    "build": "node build/build.js",
    "dev": "node build/dev.js",
    "version": "npm run build && git add -A dist"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/Raruto/leaflet-ui.git"
  },
  "keywords": [
    "leaflet",
    "map",
    "default-ui",
    "controls",
    "layers"
  ],
  "author": "Raruto",
  "license": "GPL-3.0",
  "bugs": {
    "url": "https://github.com/Raruto/leaflet-ui/issues"
  },
  "homepage": "https://github.com/Raruto/leaflet-ui#readme",
  "devDependencies": {
    "@cucumber/cucumber": "^13.3.0",
    "esbuild": "^0.28.2",
    "playwright": "^1.64.1"
  },
  "peerDependencies": {
    "leaflet": "^1.9.3 || ^2.0.0-alpha.1"
  },
  "dependencies": {
    "@raruto/leaflet-edit-osm": "0.1.0",
    "@raruto/leaflet-gesture-handling": "^1.5.2",
    "leaflet-control-layers-inline": "0.1.0",
    "leaflet-easyprint": "^2.1.9",
    "leaflet-i18n": "^0.3.5",
    "leaflet-loading": "^0.1.24",
    "leaflet-minimap": "^3.6.1",
    "leaflet-pegman": "^0.2.0",
    "leaflet-pointable": "^0.1.0",
    "leaflet-rotate": "^0.5.2",
    "leaflet-search": "^4.0.0",
    "leaflet.control.resizer": "^0.0.1",
    "leaflet.fullscreen": "^5.3.3",
    "leaflet.gridlayer.googlemutant": "^0.16.0",
    "leaflet.locatecontrol": "^0.90.1",
    "leaflet.visualclick": "^1.1.4"
  }
}
